import { call, put, takeEvery } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './siteAliasActionType';
import * as actions from './siteAliasActions';
import * as services from './siteAliasServices';
import { downloadBase64File } from "../../../../utils/fileDownloads";

function* fetchSiteAliasManagementListSaga(action) {
    try {
        const value = action?.payload ?? false;

        const response = yield call(services.getAllSiteAliasDetail, value);

        if (!response) {
            throw new Error('No response received from API');
        }

        yield put(
            actions.fetchSiteAliasManagementListSuccess(response?.values)
        );

    } catch (error) {
        const errorMessage = 'Failed to fetch Facility Alias Management list';

        console.error('Site Alias Management List API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });

        yield put(
            actions.fetchSiteAliasManagementListFailure(errorMessage)
        );
    }
}

//------Get All Sites for Site Alias Management Saga-----//
function* fetchAllSitealiaslist(action) {
    try {
        const value = action?.payload ?? false;

        const response = yield call(services.getAllSitesListforAlias, value);

        if (!response) {
            throw new Error('No response received from API');
        }

        yield put(
            actions.fetchAllSitesAliasSuccess(response?.values)
        );

    } catch (error) {
        const errorMessage = 'Failed to fetch Facility Alias Management list';

        console.error('Site Alias Management List API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });

        yield put(
            actions.fetchAllSitesAliasFailure(errorMessage)
        );
    }
}

//---------Bulk Save Site Alias Management Saga------//
function* saveSiteAliasManagementSaga(action) {
    try {
        const payload = action.payload;

        // API call
       const response = yield call(services.bulksaveSiteAliasManagement, payload);

        // success action
        yield put(actions.bulksaveSiteAliasSuccess());

        // success alert
        if (response && response.success) {
            Swal.fire({
                title: 'Success',
                text: 'Successfully facilities mapped with alias',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#6366f1',
                timer: 3000,
                timerProgressBar: true
            });
        }

        // refresh table (unmapped = false)
        yield put(actions.fetchSiteAliasManagementListRequest(false));

    } catch (error) {
        yield put(actions.bulksaveSiteAliasFailure(error));

        Swal.fire({
            title: 'Error',
            text: error?.response?.data?.message || 'Failed to save facility alias mapping',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#ef4444'
        });
    }
}

//Get Site Alias Management Details History Saga
function* fetchsitealiasdetailIdSaga(action) {
    try {
        const { SiteAliasDetailID } = action.payload;

        // Call the API
        const response = yield call(services.getSiteAliasManagementDetailsHistory, SiteAliasDetailID);

        // Dispatch success action
        yield put(actions.sitealiasmanagementhistorySuccess(response.values));

    } catch (error) {
        let errorMessage = 'Failed to fetch RPCE details';

        console.error('Fetch RPCE By ID API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });

        // Dispatch failure action with error
        yield put(actions.sitealiasmanagementhistoryFailure(errorMessage));

        // Show error notification
        Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });
    }
}

//---------Activate/Deactivate Site Alias Management Saga------//
function* activateDeactivatesitealisSaga(action) {
    try {
        const { Id, status, userId } = action.payload;

        // Call the API
        const response = yield call(services.activateDeactivateSiteAlias, Id, status, userId);
        // Dispatch success action
        yield put(actions.activatedeactivatesitealisSuccess(response));

        // Check if the operation was successful
        if (response && response.success) {
            // Show success notification
            Swal.fire({
                title: 'Success',
                //text: `Site has been ${status ? 'activated' : 'deactivated'} successfully`,
                text: response?.resultMessage,
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#6366f1',
                timer: 3000,
                timerProgressBar: true
            });

            yield put(actions.fetchSiteAliasManagementListRequest());
        } else {
            // Show error notification with specific error message
            Swal.fire({
                title: 'Error',
                text: response?.errorMessage || 'Failed to update facility alias status',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33'
            });
        }

    } catch (error) {
        let errorMessage = 'Failed to update facility alias status';

        console.error('Activate/Deactivate Site Alias API Error:', {
            status: error.response?.status,
            message: errorMessage,
            data: error.response?.data,
            timestamp: new Date().toISOString()
        });

        // Show error notification
        Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });

        // Dispatch failure action with error
        yield put(actions.activatedeactivatesitealisFailure(errorMessage));
    }
}

//-------Export Site Alias Management Saga-----//
function* exportsitealismanagement(action) {
    try {
        const response = yield call(services.ExportSiteAlias,);     
        const base64Data = response?.values || response;
        const moduleName = action?.payload?.moduleName || 'Facility Alias Management.xlsx';

        if (!base64Data) {
            throw new Error('Empty export response');
        }
        yield call(downloadBase64File, base64Data, moduleName);

        Swal.fire({
            title: 'Success',
            text: 'Facility alias exported successfully',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#6366f1',
            timer: 3000,
            timerProgressBar: true
        });

        yield put(actions.exportSitesAliasSuccess());

    } catch (error) {
        console.error('Export error:', error);

        Swal.fire({
            title: 'Error',
            text: error?.message || 'Export failed',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });

        yield put(actions.exportSitesAliasFailure(error?.message || 'Export failed'));
    }
}


export default function* watchsiteAliasSaga() {
    yield takeEvery(types.FETCH_SITE_ALIAS_MANAGEMENT_REQUEST, fetchSiteAliasManagementListSaga);
    yield takeEvery(types.FETCH_GETALLSITES_REQUEST, fetchAllSitealiaslist);
    yield takeEvery(types.EXPORT_SITE_ALIAS_MANAGEMENT_REQUEST, exportsitealismanagement);
    yield takeEvery(types.SITEALIASACTIVATEDEACTIVATE_REQUEST, activateDeactivatesitealisSaga);
    yield takeEvery(types.SITEALIASMANAGEMENT_DETAILS_REQUEST, fetchsitealiasdetailIdSaga);
    yield takeEvery(types.BULK_SAVE_SITE_ALIAS_MANAGEMANT_REQUEST, saveSiteAliasManagementSaga);
}

